import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { addStore } from 'client/shared/react-util';
import { FieldFactory } from 'client/shared/components';

@inject('formStore', 'albumsStore')
@observer
class SongForm extends Component {
	render () {
		const { formStore, albumsStore, song = {} } = this.props;
		const FieldWithStore = addStore(FieldFactory, {
			formStore,
			item: song
		});

		return (
			<div className='grid-container'>
				<div className="grid-x">
					<div className="cell">
						<h4>Song Info { song.title }</h4>
						<FieldWithStore
							fieldKey="song.artistID"
						/>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell small-12 large-9">
						<FieldWithStore
							fieldKey="song.title"
						/>
					</div>
					<div className="cell small-12 large-3">
						<FieldWithStore
							fieldKey="song.explicit"
						/>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell">
						<FieldWithStore
							fieldKey="song.albumIDs"
							optionsStore={ albumsStore }
						/>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell">
						<FieldWithStore
							fieldKey="song.embedCode"
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default SongForm;
